<template>
    <el-drawer v-model="isShowSlipDetailDrawer" class="slip-detail-main" size="30%" :close-on-click-modal="false" >
            <template #title>
                    <span class="import-title">{{title}}</span>
            </template> 
            <div class="main-center">
                <el-descriptions
                    class="margin-top"
                    :column="1"
                    border
                    width="150px"
                >
                    <el-descriptions-item label="姓名：" label-class-name="user-base-info-item-label" >
                        {{detailData.name}}
                    </el-descriptions-item>
                    <el-descriptions-item label="身份证号：">
                        {{detailData.idCardNo}}
                    </el-descriptions-item>
                    <el-descriptions-item label="银行：">
                        {{detailData.bankName}}
                    </el-descriptions-item>
                    <el-descriptions-item label="银行卡号：">
                        {{detailData.bankCardNo}}
                    </el-descriptions-item>
                    <el-descriptions-item label="开户行:">
                        {{detailData.bankDeposit}}
                    </el-descriptions-item>
                    <el-descriptions-item label="工种：">
                        {{detailData.typeOfWorkName}}
                    </el-descriptions-item>
                    <el-descriptions-item label="应发工资：">
                        {{detailData.shouldPaySalary}}
                    </el-descriptions-item>
                    <el-descriptions-item label="应扣工资：">
                        <el-descriptions
                            class="margin-top"
                            :column="1"
                            width="150px"
                        >
                            <el-descriptions-item label="社保扣除：">
                                {{detailData.socialAccountDeduction}}
                            </el-descriptions-item>
                            <el-descriptions-item label="个税扣除：">
                                {{detailData.individualIncomeTax}}
                            </el-descriptions-item>
                            <el-descriptions-item label="其他扣除：">
                                {{detailData.otherDeduction}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-descriptions-item>
                    <el-descriptions-item label="实发工资：">
                        {{detailData.actualSalary}}
                    </el-descriptions-item>
                    <el-descriptions-item label="备注：">
                        {{detailData.remarks}}
                    </el-descriptions-item>
                    <el-descriptions-item label="图片附件：">
                        <el-upload class="upload-demo" action="" :disabled="true" multiple :auto-upload="false" accept=""
                        :file-list="detailData.fileList"
                        :on-preview="impPreview"
                        list-type="picture">
                        </el-upload>
                    </el-descriptions-item>
                    <el-descriptions-item label="电话：">
                        {{detailData.phone}}
                    </el-descriptions-item>
                    <el-descriptions-item label="项目标签：">
                        {{detailData.projectName}}{{detailData.teamName?"/"+detailData.teamName:""}}{{detailData.groupName?"/"+detailData.groupName:""}}
                    </el-descriptions-item>
                </el-descriptions>
                
                <div class="timeline" style="padding: 20px 0px;">
                    <el-timeline>
                        <el-timeline-item 
                            :key="detailData.id"
                            :icon="UploadFilled"
                            type="primary"
                            color="#0bbd87"
                            size="large"
                            :hollow="true"
                            :timestamp="'1.上传'"
                            placement="top"
                            >
                            <div>{{ detailData.createUserName }} </div>
                            <div>{{(detailData.createTime+"").replace(/T/g, " ")}}</div>
                            
                        </el-timeline-item>
                        <el-timeline-item 
                            :key="detailData.id"
                            :icon="Promotion"
                            type="primary"
                            color="#0bbd87"
                            size="large"
                            :hollow="true"
                            :timestamp="detailData.sendTime?'2.已发送':'2.待发送'"
                            placement="top"
                            >
                            <div v-if="detailData.sendTime">{{ detailData.sendUserName }} </div>
                            <div v-if="detailData.sendTime">{{(detailData.sendTime+"").replace(/T/g, " ")}}</div>
                        </el-timeline-item>
                        <el-timeline-item 
                            :key="detailData.id"
                            :icon="CircleCheckFilled"
                            type="primary"
                            color="#0bbd87"
                            size="large"
                            :hollow="true"
                            :timestamp="detailData.sureTime?(detailData.status===2?'3.确认(已拒绝)':'3.已确认'):'3.待确认'"
                            placement="top"
                            >
                            <div v-if="detailData.sureTime">
                                <div>
                                    <el-image
                                    style="width: 100px; height: 100px"
                                    :src="getFileUrl(detailData.surePhotoPath)"
                                    :preview-src-list="[getFileUrl(detailData.surePhotoPath)]"
                                    :initial-index="4"
                                    fit="cover"
                                    >
                                    </el-image>
                                </div>
                                <div>{{detailData.sureOpinion?'意见：'+detailData.sureOpinion:''}}</div>
                            </div>
                            <div v-if="detailData.sureTime">{{(detailData.sureTime+"").replace(/T/g, " ")}}</div>
                        </el-timeline-item>
                        <el-timeline-item 
                            :key="detailData.id"
                            :icon="Unlock"
                            type="primary"
                            color="#0bbd87"
                            size="large"
                            :hollow="true"
                            :timestamp="detailData.auditTime?(detailData.status===4?'4.审核(已拒绝)':'4.已审核'):'4.待审核'"
                            placement="top"
                            >
                            <div v-if="detailData.auditTime">{{ detailData.auditUserName }} </div>
                            <div v-if="detailData.auditTime">{{detailData.auditOpinion?'意见：'+detailData.auditOpinion:''}}</div>
                            <div v-if="detailData.auditTime">{{(detailData.auditTime+"").replace(/T/g, " ")}}</div> 
                        </el-timeline-item>
                        <el-timeline-item 
                            :key="detailData.id"
                            :icon="Collection"
                            type="primary"
                            color="#0bbd87"
                            size="large"
                            :hollow="true"
                            :timestamp="detailData.grantTime?'5.发放':'5.待发放'"
                            placement="top"
                            >
                            <div v-if="detailData.grantTime">{{ detailData.grantUserName }} </div>
                            <div v-if="detailData.grantTime">{{(detailData.grantTime+"").replace(/T/g, " ")}}</div> 
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
            <template #footer>
                <div style="flex: auto">
                    <el-button @click="isShowSlipDetailDrawer=false">关闭</el-button>
                </div>
            </template>   
    </el-drawer >
    <el-dialog title="图片预览" v-model="showImgDialog" width="95%">
        <div style="">
            <img :src="imgUrl" style="width:100%;"/>
        </div>
    </el-dialog>
</template>
<script>
import {defineComponent, shallowRef} from 'vue'
import { UploadFilled,Promotion,CircleCheckFilled,Unlock,Collection
 } from '@element-plus/icons-vue'
import { getFileUrl } from '@/utils/common';
export default defineComponent({
     emits: ['update:modelValue'],
     data() {
      return {
            UploadFilled,Promotion,CircleCheckFilled,Unlock,Collection,
            showImgDialog:false,
            getFileUrl,
            imgUrl:null,

      }
    },
    props: {
        modelValue: Boolean,
        title: { // 标题
            type: String,
            default: '工资详情'
        },
        detailData:Object,
        
    },
    computed: {
        isShowSlipDetailDrawer: {
            get() {
                return this.modelValue; 
            },
            set(value) {
                this.$emit('update:modelValue', value); 
            }
        },
    },
    methods:{
        impPreview(file) {console.log('impPreview',file);
          if(file&&file.url){
            this.imgUrl=file.url;
            this.showImgDialog=true;
          }
        },
    }
})
</script>
<style lang="scss" scoped>
.slip-detail-main{
    width: 100%;
    height: 100%;
}
.import-title {
    font-weight: bold;
    color: #2483C6;
    font-size: 1.5em;
}
</style>
<style lang="scss">
.user-base-info-item-label {
  width: 100px;
}
</style>